<div class="person-community-history-page">
  <div class="content-container">
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ errorMessage }}</p>
    </div>

    <mat-card *ngIf="!isLoading && !errorMessage && person" class="main-card">
      <div class="table-toolbar-row">
        <app-table-surface
          [columns]="columns"
          [data]="tableData"
          [enableRowHover]="true"
          [paginationConfig]="paginationConfig"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[10, 25, 50, 100]"
          [noDataMessage]="'Esta persona todavia no tiene historial de comunidades registrado para el filtro seleccionado.'"
          [tableHeight]="'auto'"
          [cellTemplate]="cellContent"
          [activeFilters]="activeFilterChips"
          title="Historial de comunidades"
          titleIcon="swap_horiz"
          [enableSearch]="true"
          searchPlaceholder="Buscar historial..."
          [enableFilter]="true"
          [enableSort]="true"
          [sortState]="currentSort"
          [enableColumnVisibility]="true"
          [enableDensity]="true"
          [viewOptions]="[
            { value: 'table', icon: 'table_rows', label: 'Tabla' },
            { value: 'timeline', icon: 'timeline', label: 'Timeline' }
          ]"
          [activeView]="viewMode"
          [customViewTemplate]="timelineView"
          [primaryActionLabel]="canManageMembers ? 'Nuevo' : undefined"
          [readonly]="!canManageMembers"
          tableId="person-community-history-page"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (searchChange)="onToolbarSearch($event)"
          (filterRemove)="onFilterRemove($event)"
          (toolbarSortChange)="onToolbarSort($event)"
          (viewChange)="setViewMode($event)"
          (primaryActionClick)="onCreate()">
          <button
            toolbarTitleActions
            mat-icon-button
            class="history-back-button"
            type="button"
            aria-label="Volver a la ficha de la persona"
            title="Volver a la ficha de la persona"
            (click)="back()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div filterPanel class="history-filter-panel" [formGroup]="filterForm">
            <app-data-table-multi-select-filter formControlName="status" label="Estado" [options]="statusFilterOptions"></app-data-table-multi-select-filter>
            <app-data-table-multi-select-filter formControlName="community" label="Comunidad" [options]="communitySelectOptions"></app-data-table-multi-select-filter>

          </div>
        </app-table-surface>
      </div>

      <ng-template #timelineView>
        <section class="timeline-view" aria-label="Timeline del historial de comunidades">
          <div *ngIf="filteredHistory.length === 0" class="timeline-empty">
            Esta persona todavia no tiene historial de comunidades registrado para el filtro seleccionado.
          </div>

          <ol *ngIf="filteredHistory.length > 0" class="history-timeline">
            <li
              *ngFor="let item of filteredHistory; trackBy: trackByHistory"
              class="history-timeline__item"
              [class.history-timeline__item--current]="item.isCurrent">
              <div class="history-timeline__marker" aria-hidden="true">
                <mat-icon>{{ item.isCurrent ? 'home_pin' : 'location_on' }}</mat-icon>
              </div>

              <article class="history-timeline__content">
                <div class="history-timeline__main">
                  <div class="history-timeline__period">
                    <span>{{ formatPeriodStart(item) }}</span>
                    <span>{{ formatPeriodEnd(item) }}</span>
                  </div>

                  <div class="history-timeline__body">
                    <button
                      mat-button
                      type="button"
                      class="history-timeline__community"
                      (click)="navigateToUnit(item.organizationUnitId)">
                      {{ item.organizationUnitName }}
                    </button>
                    <div class="history-timeline__meta">
                      <span class="duration-cell">{{ formatDuration(item) }}</span>
                      <span class="status-badge" [class.status-badge--current]="item.isCurrent">
                        {{ item.isCurrent ? 'Actual' : 'Finalizada' }}
                      </span>
                    </div>
                    <div *ngIf="item.reason" class="history-timeline__reason">{{ item.reason }}</div>
                  </div>
                </div>

                <div *ngIf="canEdit(item) || canDelete(item)" class="history-timeline__actions">
                  <button
                    *ngIf="canEdit(item)"
                    mat-icon-button
                    type="button"
                    aria-label="Editar pase"
                    matTooltip="Editar pase"
                    (click)="onEdit(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    *ngIf="canDelete(item)"
                    mat-icon-button
                    type="button"
                    aria-label="Eliminar pase"
                    matTooltip="Eliminar pase"
                    (click)="onDelete(item)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </article>
            </li>
          </ol>
        </section>
      </ng-template>

      <ng-template #cellContent let-column="column" let-row="row">
          <ng-container *ngIf="column === 'period'">
            <div>{{ formatPeriodStart(row) }}</div>
            <div class="date-secondary">{{ formatPeriodEnd(row) }}</div>
          </ng-container>

          <span *ngIf="column === 'duration'" class="duration-cell">{{ formatDuration(row) }}</span>

          <a *ngIf="column === 'community'" (click)="navigateToUnit(row.organizationUnitId)">{{ row.organizationUnitName }}</a>

          <span *ngIf="column === 'reason'" class="reason-cell">{{ row.reason || '-' }}</span>

          <ng-container *ngIf="column === 'status'">
            <span class="status-badge" [class.status-badge--current]="row.isCurrent">
              {{ row.isCurrent ? 'Actual' : 'Finalizada' }}
            </span>
          </ng-container>

          <ng-container *ngIf="column === 'actions'">
            <div class="actions-cell">
              <button
                *ngIf="canEdit(row)"
                mat-icon-button
                type="button"
                aria-label="Editar pase"
                matTooltip="Editar pase"
                (click)="onEdit(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                *ngIf="canDelete(row)"
                mat-icon-button
                type="button"
                aria-label="Eliminar pase"
                matTooltip="Eliminar pase"
                (click)="onDelete(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </ng-container>
      </ng-template>
    </mat-card>
  </div>
</div>
